// components/mobile/BottomNavigation.jsx
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { HomeOutlined, DashboardOutlined, AppstoreOutlined, InboxOutlined, SwapOutlined } from '@ant-design/icons';
import './bottomNavigation.css';

const PERIOD_KEYS = ['today', 'yesterday', 'week', 'month'];

/*
  Entrées actives :
  - accueil   → cockpit (MobileCockpitV2)
  - direct    → sections transactionnelles de MobileActions (ventes, commandes, retours…)
  - catalogue → ?catalogue=1 (liste et fiche produit)
  - stock     → section=stock
  - more      → section=mouvements (Suivi)
  L'écran clientes ne met aucune entrée en surbrillance (pas d'entrée dédiée).
  Chaque lien conserve le param period courant de l'URL (défaut : today côté cible).
*/
export const BottomNavigation = ({ navigate, active }) => {
  const routerNavigate = useNavigate();
  const [searchParams] = useSearchParams();
  const go = navigate || routerNavigate;
  const period = PERIOD_KEYS.includes(searchParams.get('period')) ? searchParams.get('period') : '';
  const target = (params = {}) => {
    const next = new URLSearchParams(params);
    if (period) next.set('period', period);
    const query = next.toString();
    return query ? `/mobile?${query}` : '/mobile';
  };

  return (
    <nav className="mobile-action-bottom-nav" aria-label="Navigation mobile">
      <button type="button" className={active === 'accueil' ? 'is-active' : ''} onClick={() => go(target())}>
        <HomeOutlined /><span>Accueil</span>
      </button>
      <button type="button" className={active === 'direct' ? 'is-active' : ''} onClick={() => go(target({ section: 'ventes' }))}>
        <DashboardOutlined /><span>En direct</span>
      </button>
      <button type="button" className={active === 'catalogue' ? 'is-active' : ''} onClick={() => go(target({ catalogue: '1' }))}>
        <AppstoreOutlined /><span>Catalogue</span>
      </button>
      <button type="button" className={active === 'stock' ? 'is-active' : ''} onClick={() => go(target({ section: 'stock', status: 'alert' }))}>
        <InboxOutlined /><span>Stock</span>
      </button>
      <button type="button" className={active === 'more' ? 'is-active' : ''} onClick={() => go(target({ section: 'mouvements' }))}>
        <SwapOutlined /><span>Suivi</span>
      </button>
    </nav>
  );
};
